<!--
 * @Author: vince
 * @Date: 2021-08-18 09:23:11
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2022-01-26 15:14:49
 * @Description: 
-->
<template>
	<el-select size="small" v-if="controlType=='select'" :value="schoolTemp" :disabled="disabled" :multiple="multiple" filterable :loading="loading" placeholder="请选择" :filter-method="remoteMethod" value-key="schoolCode" :clearable="clearable" @change="change">
		<el-option v-if="checkAll"  label="全部" value="" ></el-option>
		<el-option v-for="item in options" :label="item.schoolName" :value="item" :key="item.schoolName"></el-option>
	</el-select>
	<el-checkbox-group v-else-if="controlType=='checkbox'" v-model="schoolTemp" @change="change">
		<el-checkbox :label="item" v-for="(item,index) in options" :key="index">{{item.schoolName}}</el-checkbox>
	</el-checkbox-group>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
	name: "schoolSelector",
	model: {
		prop: "value",
		event: "change"
	},
	data() {
		return {
			loading: false,
			options: [],
			schoolTemp: []
		};
	},
	computed: {
		...mapState(["userInfo"]),
		...mapGetters(["schoolCode"])
	},
	props: {
		checkAll:{
			type:Boolean,
			default:false
		},
		controlType: {
			type: String,
			default: "select"
		},
		value: {
			type: Array | Object
		},
		disabled: {
			type: Boolean,
			default: false
		},
		multiple: {
			type: Boolean,
			default: false
		},
		clearable:{
			type: Boolean,
			default: true
		}
	},
	watch: {
		value: {
			handler(v) {
				this.schoolTemp = v;
			},
			immediate: true
		}
	},
	mounted() {
		this.options = this.userInfo.teacherSchoolList;
	},
	methods: {
		remoteMethod(query) {
			if (query != "") {
				this.options = this.userInfo.teacherSchoolList.filter(f => {
					return (
						f.schoolCode.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
						f.schoolName.toLowerCase().indexOf(query.toLowerCase()) > -1
					);
				});
			} else {
				this.options = this.userInfo.teacherSchoolList;
			}
		},
		change(v) {
			this.schoolTemp = v;
			this.$emit("change", v);
		}
	}
};
</script>

<style>
</style>